export enum EnumTipoControleModulo {
    NaoControla = 0,
    Terminal = 1,
    Filial = 2
}